
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#161718","fill-rule":"evenodd","d":"M4.5 18.5h1c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1zm13-12v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1zm-9 12h7c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1z"}})])
          )
        }
      }
    